import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { LoadingScreen } from '../screens/LoadingScreen';
import { LandingPage } from '../screens/home/LandingPage';
import { AuthNavigator } from './AuthNavigator';
import { SalesRepNavigator } from './SalesRepNavigator';
import { ManagerNavigator } from './ManagerNavigator';
import { TradeshowOrderScreen } from '../screens/shared/TradeshowOrderScreen';
import { PlanogramOrderScreen } from '../screens/shared/PlanogramOrderScreen';

// Import new screens
import { PrivacyPolicy } from '../screens/legal/PrivacyPolicy';
import { TermsOfService } from '../screens/legal/TermsOfService';
import { ContactUs } from '../screens/marketing/ContactUs';
import { AboutUs } from '../screens/marketing/AboutUs';
import { FAQ } from '../screens/marketing/FAQ';
import { BlogList } from '../screens/blog/BlogList';
import { BlogPost } from '../screens/blog/BlogPost';

export const RootNavigator = () => {
  console.log("RootNavigator component rendering");
  const { user, userRole, loading } = useAuth();
  
  console.log("RootNavigator - User:", user?.email);
  console.log("RootNavigator - UserRole:", userRole);
  console.log("RootNavigator - Loading:", loading);

  if (loading) {
    return <LoadingScreen />;
  }

  // Helper to check if user has manager-level access (manager, hand-lead, or admin)
  const hasManagerAccess = userRole === 'manager' || userRole === 'hand-lead' || userRole === 'admin';

  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      
      {/* Public Marketing & Legal Routes */}
      <Route path="/about" element={<AboutUs />} />
      <Route path="/contact" element={<ContactUs />} />
      <Route path="/faq" element={<FAQ />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/terms" element={<TermsOfService />} />
      
      {/* Public Blog Routes */}
      <Route path="/blog" element={<BlogList />} />
      <Route path="/blog/:slug" element={<BlogPost />} />

      {/* Public operational forms (same as McKenzie Portal; no login required) */}
      <Route path="/tradeshow" element={<TradeshowOrderScreen />} />
      <Route path="/planogram-order" element={<PlanogramOrderScreen />} />

      {!user || !userRole ? (
        <Route path="/*" element={<AuthNavigator />} />
      ) : userRole === 'sales-representative' ? (
        <Route path="/*" element={<SalesRepNavigator />} />
      ) : hasManagerAccess ? (
        <Route path="/*" element={<ManagerNavigator />} />
      ) : (
        // Default to Auth if role is not recognized
        <Route path="/*" element={<AuthNavigator />} />
      )}
    </Routes>
  );
};
